import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "src/components/common/functions";

export async function outsideDivisionsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    let shouldRedirect = false;

    if (!url.searchParams.has("q")) {
        url.searchParams.set("q", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    for (const [key] of url.searchParams) {
        if (!["q", "page", "limit"].includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());

    const res = await myAxios({ fileName: "outside/divisions/readDivisions.php" });
    if (!res) throw redirect("..");
    return { divisions: res.data };
}

const urlMap = {
    create: "outside/divisions/createDivision.php",
    update: "outside/divisions/updateDivision.php",
    delete: "outside/divisions/deleteDivision.php",
};

export async function outsideDivisionsAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    const intent = String(formData.get("intent") ?? "");
    const url = urlMap[intent as keyof typeof urlMap];
    if (!url) throw new Response("Invalid intent", { status: 400 });

    const res = await myAxios({ fileName: url, formData });
    if (!res) throw redirect("..");

    const requestUrl = new URL(request.url);
    return redirect(requestUrl.pathname + requestUrl.search);
}
